import { combineEpics } from 'redux-observable';
import { startImportCatalogEpic } from './start-import-catalog';
import { catalogImportedEpic } from './catalog-imported';
import { trackImportProgressEpic } from './track-progress';

const importCatalogEpic = combineEpics(
  startImportCatalogEpic,
  catalogImportedEpic,
  trackImportProgressEpic
);

export default importCatalogEpic;
